function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object, disabled, on) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "on": {
          click: disabled ? null : $helpers.toggleSwitch,
        },
        "class": Object.assign({}, {
          'switch-on': on,
          'switch-off': !on,
          'disabled': disabled,
        }, {
          'mp-switch': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
          "attrs": __vjadeStringifyAttrsIfObj({
            icon: 'checkmark'
          }),
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "disabled" in locals ? locals.disabled : typeof disabled !== "undefined" ? disabled : undefined, "on" in locals ? locals.on : typeof on !== "undefined" ? on : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;